import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=78c503ad&scoped=true"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js"
import style0 from "./PrimaryNavItem.vue?vue&type=style&index=0&id=78c503ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c503ad",
  null
  
)

export default component.exports